import { createReducer, on } from '@ngrx/store';

import { INITIAL_MENTIONABLE_USERS_STATE } from './mentionable-users.model';
import {
  MentionableUsersActions,
  MentionableUsersApiActions,
} from './mentionable-users.actions';

export const mentionableUsersReducer = createReducer(
  INITIAL_MENTIONABLE_USERS_STATE,

  on(MentionableUsersActions.loadMentionableUsers, (state) => ({
    ...state,
    loading: true,
  })),

  on(
    MentionableUsersApiActions.loadMentionableUsersSuccess,
    (state, { users, cachedAt }) => ({
      ...state,
      users,
      loading: false,
      cachedAt,
    }),
  ),
);
